document.addEventListener('click', event => {
  if (event.target.classList.contains('hide-on-click')) {
    event.target.remove();
  }
})
